import {useState, useEffect} from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Loading from '../../common/Loading';


export default function LoadListFilterDaysStationaryOperatorList(props) {
    //console.debug("RTS Break LoadListFilterDaysStationaryOperatorList");

    const [isLoading, setIsLoading] = useState(true);

    const [daysStationaryOperator, setDaysStationaryOperator] = useState();

    useEffect(() => {
        if(props.daysStationaryOperator===null){
            setDaysStationaryOperator(">=");
        }
        else{
            setDaysStationaryOperator(props.daysStationaryOperator);
        }

        setIsLoading(false);
    }, [props]); 


    function valChange(e){
        props.setDaysStationaryOperatorFx(e.target.value);
        setDaysStationaryOperator(e.target.value);
    }    


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <FormControl size="small" sx={{ m: 0, minWidth: 70 }}>
                <Select
                    labelId=""
                    id="daysStationaryOperator"
                    value={daysStationaryOperator}
                    onChange={valChange}
                    label="Operator"
                >
                    <MenuItem value={">="}>&gt;=</MenuItem>
                    <MenuItem value={"<="}>&lt;=</MenuItem>
                </Select>
            </FormControl>


        </>
    );
}

